import { useContext, useEffect } from 'react';
import { AppStateContext } from '../contexts/AppStateContext';
import { useClient } from '../../utils/prismicConfig';
import { TermsContext } from '../contexts/TermsContext';

const TermsChecker = (props) => {
  const { online } = props;

  const [termDocs, setTermDocs] = useContext(TermsContext);
  const [appState] = useContext(AppStateContext);
  const client = useClient(appState);

  useEffect(() => {
    const getTermDocs = async () => {
      if (client) {
        try {
          const saTermsDoc = await client.getSingle('terms_and_conditions_summa_arvot');
          const mtTermsDoc = await client.getSingle('terms_and_conditions_maastotaulu');
          const mtWebTermsDoc = await client.getSingle('terms_and_conditions_maastotaulu_verkko');

          const termDocs = [saTermsDoc, mtTermsDoc, mtWebTermsDoc].filter(Boolean);

          setTermDocs(termDocs);
        } catch (error) {
          console.error(error);
        }
      }
    };

    if (termDocs.length === 0 && online) {
      getTermDocs();
    }
  }, [client, termDocs, setTermDocs, online]);

  return null;
};

export default TermsChecker;
